import { Suspense } from 'react';
import { Route, Routes } from 'react-router';

import CharityVettingAcceptsAllFoodAndNonFoodEntry from '../../../common-flow/entries/CharityVettingAcceptsAllFoodAndNonFoodEntry';
import CharityVettingAcceptsAllFoodsEntry from '../../../common-flow/entries/CharityVettingAcceptsAllFoodsEntry';
import CharityVettingAcceptsAllNonFoodEntry from '../../../common-flow/entries/CharityVettingAcceptsAllNonFoodEntry';
import CharityVettingContactDetailsEntry from '../../../common-flow/entries/CharityVettingContactDetailsEntry';
import CharityVettingDonationPreferencesEntry from '../../../common-flow/entries/CharityVettingDonationPreferencesEntry';
import CharityVettingGetStartedEntry from '../../../common-flow/entries/CharityVettingGetStartedEntry';
import CharityVettingLegalRepresentativeEntry from '../../../common-flow/entries/CharityVettingLegalRepresentativeEntry';
import CharityVettingManualContactDetailsEntry from '../../../common-flow/entries/CharityVettingManualContactDetailsEntry';
import CharityVettingReviewDetailsEntry from '../../../common-flow/entries/CharityVettingReviewDetailsEntry';
import CharityVettingSearchDetailsEntry from '../../../common-flow/entries/CharityVettingSearchDetailsEntry';
import CharityVettingSocialAccountsEntry from '../../../common-flow/entries/CharityVettingSocialAccountsEntry';
import CharityVettingUnwantedFoodEntry from '../../../common-flow/entries/CharityVettingUnwantedFoodEntry';
import { vettingPath } from '../../../common-flow/entries/path';

import CharityKRSRoute from './CharityKRSRoute';
import CharityNIPRoute from './CharityNIPRoute';
import OrganisationTypeRoute from './OrganisationTypeRoute';
import PublicBenefitRoute from './PublicBenefitRoute';

const CharityVettingRoutesPL = () => {
  return (
    <Suspense fallback={null}>
      <Routes>
        <Route path={vettingPath.getStartedPath} element={<CharityVettingGetStartedEntry />} />
        <Route path={vettingPath.searchPath} element={<CharityVettingSearchDetailsEntry />} />
        <Route
          path={vettingPath.contactDetailsPath}
          element={<CharityVettingContactDetailsEntry />}
        />
        <Route
          path={vettingPath.manualContactDetailsPath}
          element={<CharityVettingManualContactDetailsEntry />}
        />
        <Route
          path={vettingPath.legalRepresentativePath}
          element={<CharityVettingLegalRepresentativeEntry />}
        />
        <Route path={vettingPath.registrationPath} element={<OrganisationTypeRoute />} />
        <Route path={vettingPath.publicBenefitPath} element={<PublicBenefitRoute />} />
        <Route path={vettingPath.krsPath} element={<CharityKRSRoute />} />
        <Route path={vettingPath.nipPath} element={<CharityNIPRoute />} />
        <Route
          path={vettingPath.donationPreferencesPath}
          element={<CharityVettingDonationPreferencesEntry />}
        />
        <Route
          path={vettingPath.acceptAllFoodsPath}
          element={<CharityVettingAcceptsAllFoodsEntry />}
        />
        <Route
          path={vettingPath.acceptAllNonFoodPath}
          element={<CharityVettingAcceptsAllNonFoodEntry />}
        />
        <Route
          path={vettingPath.acceptAllFoodAndNonFoodPath}
          element={<CharityVettingAcceptsAllFoodAndNonFoodEntry />}
        />
        <Route path={vettingPath.unwantedFoodPath} element={<CharityVettingUnwantedFoodEntry />} />
        <Route
          path={vettingPath.socialAccountsPath}
          element={<CharityVettingSocialAccountsEntry />}
        />
        <Route
          path={vettingPath.reviewDetailsPath}
          element={<CharityVettingReviewDetailsEntry />}
        />
      </Routes>
    </Suspense>
  );
};

export default CharityVettingRoutesPL;
